export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {
    'title': 'MES OFA',
    'url': '/mes-ofa',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mes propositions',
        'url': '/propositions',
        'service': 'ofa'
      },
      {
        'title': 'Recap soldes',
        'url': '/recap-solde',
        'service': 'ofa'
      },
    ]
  },

  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes collaborateurs',

        'url': '/collaborateurs',

        'service': 'ofa'

      }

    ]

  },

];

export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE_HIERARCHIE: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes collaborateurs',

        'url': '/collaborateurs',

        'service': 'ofa'

      }

    ]

  },

];

export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },
  {
    'title': 'MES OFA',
    'url': '/mes-ofa',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mes propositions',
        'url': '/propositions',
        'service': 'ofa'
      },
      {
        'title': 'Recap soldes',
        'url': '/recap-solde',
        'service': 'ofa'
      },
    ]
  },
  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      }

    ]

  },

];

export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1_HIERARCHIE: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      }

    ]

  },

];

export const NAVIGATION_UTILISATEUR_RESPONSABLE: any[] = [

  {

    title: 'Tableau de bord',

    icon: 'ft-home',

    url: '/dashboard',

  },
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes collaborateurs',

        'url': '/collaborateurs',

        'service': 'ofa'

      }

    ]

  },

];

export const NAVIGATION_UTILISATEUR_RESPONSABLE_HIERARCHIE: any[] = [

  {

    title: 'Tableau de bord',

    icon: 'ft-home',

    url: '/dashboard',

  },
  {

    'heading': true,

    'title': 'OFA'

  },
  {
    'title': 'MES OFA',
    'url': '/mes-ofa',
    'icon': 'ft-book',
    'service': 'ofa',
    'childrens': [
      {
        'title': 'Mes propositions',
        'url': '/propositions',
        'service': 'ofa'
      },
      {
        'title': 'Recap soldes',
        'url': '/recap-solde',
        'service': 'ofa'
      },
    ]
  },
  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      },

      {

        'title': 'Mes collaborateurs',

        'url': '/collaborateurs',

        'service': 'ofa'

      }

    ]

  },

];


export const NAVIGATION_UTILISATEUR_RESPONSABLE_SANS_N1: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      }

    ]

  },

];

export const NAVIGATION_UTILISATEUR_RESPONSABLE_SANS_N1_HIERARCHIE: any[] = [
  {

    'heading': true,

    'title': 'OFA'

  },

  {

    'title': 'Mon DataBook',

    'url': '/mon-databook',

    'icon': 'ft-book',

    'service': 'ofa',

    'childrens': [

      {

        'title': 'Moi',

        'url': '/moi',

        'service': 'ofa'

      }

    ]

  },

];


